
		export default class PageState{
			
		}